import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'
import { API_ROOT } from '@/api/config'
import { captchaHeaders } from '@/api/recaptcha/recaptchaApi'

export default {
  getApplicationForm: function (code) {
    return Http.get({
      base_url: API_ROOT,
      url: `application/${code}/form`
    })
  },
  getApplicationFormAsCustomer: function (code) {
    return Http.get({
      url: `application/${code}/form`
    })
  },
  getApplicationExams: function (code) {
    if (code) {
      return Http.get({
        url: `application/${code}/exams`
      })
    }
    return Http.get({
      url: `application/exams`
    })
  },
  postApplicationFormAsGuest: function (serviceType, formAndFileData, captchaToken) {
    return Http.post({
      base_url: API_ROOT,
      url: `application/${serviceType}`,
      data: Transform.createMultipartFormData(formAndFileData),
      headers: captchaHeaders(captchaToken)
    })
  },
  postApplicationFormAsCustomer: function (serviceType, formAndFileData) {
    return Http.post({
      url: `application/${serviceType}`,
      data: Transform.createMultipartFormData(formAndFileData)
    })
  },
  postInitAssently: function (serviceType, formAndFileData, captchaToken) {
    return Http.post({
      url: `application/init-assently/${serviceType}`,
      data: Transform.createMultipartFormData(formAndFileData),
      headers: captchaHeaders(captchaToken)
    })
  },
  postValidateAssently: function (serviceType, formAndFileData, authToken, identityToken) {
    let data = Transform.createMultipartFormData(formAndFileData)
      data.append('assently_data', JSON.stringify({
        'auth_token': authToken,
        'identity_token': identityToken
      })
    )
    return Http.post({
      url: `application/validate-assently/${serviceType}`,
      data: data
    })
  },
  getAssentlyUrl: function () {
    return Http.get({
      url: `application/assently-url`
    })
  }
}
